export const RouteConstants = {
    HOME: '',
    DEMO_PAGE: 'signup',
    SUCCESS_PAGE: 'signup/confirm',
    ERROR_PAGE: 'error',
    WHITELIST_PAGE: 'whitelist',
    PRIVACY_PAGE: 'privacy',
    USERAGREEMENT_PAGE: 'userAgreement'
};
